import * as React from "react";
import { useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { useTranslation } from "react-i18next";

export default function ConsumptionSettings() {
  const { t } = useTranslation();

  const [isReady, setIsReady] = useState(false);
  const [currentConsumption, setCurrentConsumption] = useState("");
  const [price, setPrice] = useState("");

  return (
    <Card>
      <CardContent>
        <Stack spacing={3} sx={{ maxWidth: 500 }}>
          <Typography variant="h6">
            {t("nodeComponents.consumptionSettings.title", "Tüketim Ayarları")}
          </Typography>

          <FormControlLabel
            control={
              <Switch
                checked={isReady}
                onChange={(e) => setIsReady(e.target.checked)}
              />
            }
            label={
              isReady
                ? t("nodeComponents.consumptionSettings.ready", "Şarj İstasyonu Hazır")
                : t("nodeComponents.consumptionSettings.notReady", "Şarj İstasyonu Hazır Değil")
            }
          />

          <Button variant="contained" color="primary">
            {t("nodeComponents.consumptionSettings.startCharging", "Şarjı Başlat")}
          </Button>

          <TextField
            label={t(
              "nodeComponents.consumptionSettings.currentConsumption",
              "Anlık Sarfiyat"
            )}
            value={currentConsumption}
            onChange={(e) => setCurrentConsumption(e.target.value)}
            type="number"
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">kWh</InputAdornment>,
            }}
          />

          <TextField
            label={t("nodeComponents.consumptionSettings.price", "Fiyat")}
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            type="number"
            fullWidth
            InputProps={{
              endAdornment: <InputAdornment position="end">kWh</InputAdornment>,
            }}
          />

          <Button variant="contained">
            {t(
              "nodeComponents.consumptionSettings.updateConsumption",
              "Sarfiyatı Güncelle"
            )}
          </Button>

          <Button variant="contained" color="error">
            {t("nodeComponents.consumptionSettings.endCharging", "Şarjı Bitir")}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
